var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_grid_path: "/students/grid",
          order_column: "name",
          hide_actions: "true",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function () {
              return [
                _c(
                  "vs-th",
                  { key: "student_name", attrs: { "sort-key": "name" } },
                  [_vm._v(_vm._s(_vm.$t("student.name")))]
                ),
                _c(
                  "vs-th",
                  { key: "student_email", attrs: { "sort-key": "email" } },
                  [_vm._v(_vm._s(_vm.$t("student.email")))]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "name", attrs: { width: "40%" } }, [
                      _c("span", [_vm._v(_vm._s(tr.name))]),
                    ]),
                    _c("vs-td", { key: "email", attrs: { width: "40%" } }, [
                      _c("span", [_vm._v(_vm._s(tr.email))]),
                    ]),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }